import { render, staticRenderFns } from "./PageCategoryContainer.vue?vue&type=template&id=bf70e8ae&"
import script from "./PageCategoryContainer.vue?vue&type=script&lang=js&"
export * from "./PageCategoryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports